export const productKeys = {
  all: (orgId: string) => ["products", orgId] as const,
  detail: (orgId: string, id: string) => ["products", orgId, id] as const,
};
